var _excluded = ["childName", "err", "level", "levelName", "v", "msg", "name", "src", "time"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { TRACE, DEBUG, INFO, WARN, ERROR, FATAL } from '@browser-bunyan/levels';
var css = {
  levels: {
    trace: 'color: DeepPink',
    debug: 'color: GoldenRod',
    info: 'color: DarkTurquoise',
    warn: 'color: Purple',
    error: 'color: Crimson',
    fatal: 'color: Black'
  },
  def: 'color: DimGray',
  msg: 'color: SteelBlue',
  src: 'color: DimGray; font-style: italic; font-size: 0.9em'
};
export var ConsoleFormattedStream = function () {
  function ConsoleFormattedStream() {
    _classCallCheck(this, ConsoleFormattedStream);
  }
  return _createClass(ConsoleFormattedStream, [{
    key: "write",
    value: function write(_ref) {
      var childName = _ref.childName,
        err = _ref.err,
        level = _ref.level,
        levelName = _ref.levelName,
        v = _ref.v,
        msg = _ref.msg,
        name = _ref.name,
        src = _ref.src,
        time = _ref.time,
        extraFields = _objectWithoutProperties(_ref, _excluded);
      var levelCss;
      var defaultCss = css.def;
      var msgCss = css.msg;
      var srcCss = css.src;
      var loggerName = childName ? [name, childName].join('/') : name;
      var formattedLevelName = [Array(6 - levelName.length).join(' '), levelName].join('').toUpperCase();
      if (level === TRACE) {
        levelName = 'debug';
      } else if (level === FATAL) {
        levelName = 'error';
      }
      var consoleMethod = typeof console[levelName] === 'function' ? console[levelName] : console.log;
      if (level < DEBUG) {
        levelCss = css.levels.trace;
      } else if (level < INFO) {
        levelCss = css.levels.debug;
      } else if (level < WARN) {
        levelCss = css.levels.info;
      } else if (level < ERROR) {
        levelCss = css.levels.warn;
      } else if (level < FATAL) {
        levelCss = css.levels.error;
      } else {
        levelCss = css.levels.fatal;
      }
      var padZeros = function padZeros(number, len) {
        return [Array(len + 1 - String(number).length).join('0'), number].join('');
      };
      var logArgs = [];
      logArgs.push("[%s:%s:%s:%s] %c%s%c: %s: %c%s ".concat(src ? '%c%s' : ''));
      logArgs.push(padZeros(time.getHours(), 2));
      logArgs.push(padZeros(time.getMinutes(), 2));
      logArgs.push(padZeros(time.getSeconds(), 2));
      logArgs.push(padZeros(time.getMilliseconds(), 4));
      logArgs.push(levelCss);
      logArgs.push(formattedLevelName);
      logArgs.push(defaultCss);
      logArgs.push(loggerName);
      logArgs.push(msgCss);
      logArgs.push(msg);
      if (src) {
        logArgs.push(srcCss);
        logArgs.push(src);
      }
      if (Object.keys(extraFields).length) {
        logArgs.push('\n');
        logArgs.push(extraFields);
      }
      if (err && err.stack) {
        logArgs.push('\n');
        logArgs.push(err.stack);
      }
      consoleMethod.apply(console, logArgs);
    }
  }]);
}();